import React, {ReactElement, useEffect, useState} from 'react';
import {Icon} from "@fluentui/react";
import { useSettingReveal } from '../../hooks/useSettingReveal';

interface IAccordionProps {
    title?: string;
    titleComponent?: ReactElement
    beginExpanded?: boolean;
    onToggle?: (expanded: boolean) => void;
    useChevron?: boolean;
    indentWidth?: number;
    teaser?: string;
}

const Accordion: React.FC<IAccordionProps> = (props) => {
    const [isActive, setIsActive] = useState(false);
    useEffect(() => {
        if(props.beginExpanded){
            setIsActive(true)
        }
    }, [props.beginExpanded]);
    // Lets a settings deep link open this accordion to reach a control inside it.
    const reveal = useSettingReveal(isActive, () => setIsActive(true));
    return (
        <div {...reveal.revealProps} className="accordion">
            <div className="accordion-item">
                {props.titleComponent ? 
                    <div style={{display: 'inline-flex'}} onClick={(event) => {
                        if(props?.onToggle){
                            props.onToggle(!isActive)
                        }
                        setIsActive(!isActive)}}>
                        {props.useChevron && 
                            <div className="chevron-icon">
                                <Icon 
                                    iconName={isActive ? 'ChevronDown': 'ChevronUp'} 
                                    style={{height: '20px', width: '20px', paddingTop: '30px'}}
                                />
                            </div>}
                        {props.titleComponent} 
                    </div> : 
                    <div className={`accordion-title${isActive ? '-active' : ''}`} onClick={(event) => {
                        if(props?.onToggle){
                            props.onToggle(!isActive)
                        }
                        setIsActive(!isActive)
    
                    }}>
                    <div style={{display: 'inline-flex', justifyContent: 'space-between'}}>
                    {props.useChevron &&
                        <Icon
                            iconName={isActive ? 'ChevronDown': 'ChevronUp'}
                            style={{height: '20px', width: '20px', paddingLeft: '5px'}}
                        />}
                        <div className={"accordion-inner"}>{props.title}</div>{props.teaser && <div className="accordion-teaser">{props.teaser}</div>}
                    </div>
                </div>}
                {isActive && <div className="accordion-content" style={{paddingLeft: `${props.indentWidth ?? 0}px`}}>{props.children}</div>}
                {/* Collapsed, but a deep link is looking: render hidden so it can be found. */}
                {reveal.renderCollapsedChildren && <div className="accordion-content" style={reveal.hiddenStyle}>{props.children}</div>}
            </div>
        </div>
    );
}

export default Accordion;